<template>
  <div class="tool-line-page" v-if="isApp&&showTool" id="navtool">
    <div class="tool-line">
        <div class="tool-line-black" @click="navToUrl('ciw://mv/template?needlogin=1')">
          <div class="tool-line-black-icon">
            <img class="tool-line-black-img" src="../../assets/registry/navInvitation.png" />
          </div>
          <div class="tool-line-black-text">结婚</div>
          <div class="tool-line-black-text">请柬</div>
        </div>
        <div class="tool-line-black" @click="navToUrl('ciw://mv/home?needlogin=1')">
          <div class="tool-line-black-icon">
            <img class="tool-line-black-img" src="../../assets/registry/navMV.png" />
          </div>
          <div class="tool-line-black-text">婚礼</div>
          <div class="tool-line-black-text">MV</div>
        </div>
        <div class="tool-line-black" @click="navToUrl('/luckyday/calendar')" v-if="fromTo!=1">
          <div class="tool-line-black-icon">
            <img class="tool-line-black-img" src="../../assets/registry/navJiri.png" />
          </div>
          <div class="tool-line-black-text">结婚</div>
          <div class="tool-line-black-text">吉日</div>
        </div>
        <div class="tool-line-black" @click="navToUrl('/budget/')" v-if="fromTo!=2">
          <div class="tool-line-black-icon">
            <img class="tool-line-black-img" src="../../assets/registry/navBudget.png" />
          </div>
          <div class="tool-line-black-text">结婚</div>
          <div class="tool-line-black-text">预算</div>
        </div>
        <div class="tool-line-black" @click="navToUrl('/task/')" v-if="fromTo!=3">
          <div class="tool-line-black-icon">
            <img class="tool-line-black-img" src="../../assets/registry/navTask.png" />
          </div>
          <div class="tool-line-black-text">结婚</div>
          <div class="tool-line-black-text">任务</div>
        </div>
        <div class="tool-line-black" @click="navToUrl('/registry/')" v-if="fromTo!=4">
          <div class="tool-line-black-icon">
            <img class="tool-line-black-img" src="../../assets/registry/navRegistry.png" />
          </div>
          <div class="tool-line-black-text">登记</div>
          <div class="tool-line-black-text">指南</div>
        </div>
        <div class="tool-line-black" @click="navToUrl('/vows/')" v-if="fromTo!=5">
          <div class="tool-line-black-icon">
            <img class="tool-line-black-img" src="../../assets/registry/navVows.png" />
          </div>
          <div class="tool-line-black-text">婚礼</div>
          <div class="tool-line-black-text">致辞</div>
        </div>
      </div>
      <div class="tool-line-bg" @click="closeToolEvent()"></div>
    </div>
</template>

<script>
import AppCall from '../../pages/preview/appcall/utils/appcall.js'
import browers from '../../../plugins/browser.js'
window.HBHGlobal = ''
export default {
  data() {
    return {
      showTool: false, //显示工具导航
      isApp: false,
    }
  },
  props: {
    fromTo: {
      type: Number,
      default: 1 //1：吉日  2：预算  3：任务  4：登记处  5：致辞
    }
  },
  mounted() {
    var that = this
    that.isApp = browers().isApp
    if(that.isApp){
      HBHGlobal = this
      AppCall.callapp(
        'ui_navigation_right_btn',
        {
          isShow: '1',
          // title: '备婚小助手',
          iconUrl:
            'https://img.hbhcdn.com/dmp/other/1578326400/jh-img-orig-ga_1214451833623707648_80_80_2862.png'
        },
        'HBHGlobal.openToolEvent'
      )
      //页面跳转后隐藏
      window.onunload = function() {
        AppCall.callapp(
          'ui_navigation_right_btn',
          {
            isShow: '2',
            // title: '备婚小助手',
            // iconUrl:
            //   'https://img.hbhcdn.com/dmp/other/1578326400/jh-img-orig-ga_1214451833623707648_80_80_2862.png'
          },
          ''
        )
      };
    }
  },
  methods: {
    /**
     * 小助手导航显示
     */
    openToolEvent(){
      var that = this
      that.showTool = true
    },
    /**
     * 小助手导航隐藏
     */
    closeToolEvent(){
      var that = this
      that.showTool = false
    },
    /**
     * 导航条跳转地址
     */
    navToUrl(url) {
      var that = this
      // console.log(url)
      if (url == null) {
        location.assign(GLOBAL.getIndexPage())
      } else {
        location.assign(url)
      }
    }
  }
}
</script>

<style>
.tool-line-page{
  width: 100%;
  height: 100%;
  z-index: 999999999;
  position: fixed;
}
.tool-line {
  height: 11.5rem;
  position: fixed;
  top: 0;
  padding: 0 0.45rem;
  background: rgba(255, 255, 255, 1);
  box-shadow:0rem 0rem 2rem 0rem rgba(51,51,51,0.2);
  z-index: 10;
}
.tool-line-bg {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 11.5rem;
  opacity: 0;
}
.tool-line-black {
  width: 6.1rem;
  height: 5.58rem;
  margin-top: 2.9rem;
  /* margin-bottom: 1.5rem; */
  float: left;
}
.tool-line-black-icon {
  width: 2.3rem;
  height: 2.3rem;
  margin: 0 auto;
  margin-bottom: 0.85rem;
}
.tool-line-black-img {
  width: 2.3rem;
  height: 2.3rem;
}
.tool-line-black-text {
  width: 6.1rem;
  height: 1.3rem;
  line-height: 1.3rem;
  font-size: 1.2rem;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  text-align: center;
  font-family: PingFang-SC-Regular, PingFang-SC;
}
</style>
